export default __webpack_public_path__ + "static/media/jrc_logo_icon_white.5fb69cef.ai";